import { render, staticRenderFns } from "./Teen3.vue?vue&type=template&id=73656764&scoped=true&"
import script from "./Teen3.vue?vue&type=script&lang=js&"
export * from "./Teen3.vue?vue&type=script&lang=js&"
import style0 from "./Teen3.vue?vue&type=style&index=0&id=73656764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73656764",
  null
  
)

export default component.exports